module.exports = __webpack_public_path__ + "img/1.ce9d904b.jpg";